import noop from 'lodash/noop'
import { useShallowCompareEffect, useUpdateEffect, useEffectOnce } from 'react-use'
import { canIUse, globalShare, setShareState } from '@bcz/fe-interface'

/**
 * 全局分享
 * @param {import('@bcz/fe-interface').GlobalShareOption & { enabled?: boolean }} options
 */
export function useGlobalSharing({ enabled = true, ...opts }) {
  useShallowCompareEffect(() => {
    if (canIUse('globalShare')) {
      globalShare(opts)
    }
  }, [opts])

  useEffectOnce(() => {
    if (canIUse('setShareState')) {
      setShareState(enabled).catch(noop)
      return () => {
        setShareState(false).catch(noop)
      }
    }
  })

  useUpdateEffect(() => {
    if (canIUse('setShareState')) {
      setShareState(enabled).catch(noop)
    }
  }, [enabled])
}
